import styled from 'styled-components';

export const Title = styled.div`
  font-size: 12px;
  line-height: 18px;
  color: #ffffff;
`;
